import { createContext } from "react";
import { IModalUtilities } from "../types";
import { doNothing } from "@edgetier/utilities";

const defaultContext: IModalUtilities = {
    canDismiss: true,
    canClose: true,
    closeModal: doNothing,
    isOpen: false,
    onCloseModal: doNothing,
    openModal: doNothing,
    updateTitle: doNothing,
    title: undefined,
};

export const ModalContext = createContext(defaultContext);
